import { ReactNode } from 'react'
import { toast, type ToastT } from 'sonner'

export function showSuccessToast(content: ReactNode) {
  return toast.success(content)
}

export function showInfoToast(content: ReactNode) {
  return toast.info(content)
}

export function showWarningToast(content: ReactNode) {
  return toast.warning(content)
}

export function showErrorToast(content: ReactNode) {
  return toast.error(content)
}

export function showStickyToast(content: ReactNode, position: ToastT['position'] = 'bottom-right', data?: ToastT) {
  return toast(content, {
    duration: Infinity,
    position,
    classNames: { toast: 'bg-muted! @container!', error: 'bg-destructive!' },
    ...data,
  })
}

export function dismissToast(id: string) {
  return toast.dismiss(id)
}
